import React, { useEffect, useCallback } from 'react';

import { createPortal } from 'react-dom';

import { ToastContainer, toast } from 'react-toastify';

import DialogModal from './DialogModal';

import { useUiStore } from '../../store';

export default function GlobalUi() {
  const setNotify = useUiStore((state) => state.setNotify);
  const setNotifyApiError = useUiStore((state) => state.setNotifyApiError);
  const setNotifySuccess = useUiStore((state) => state.setNotifySuccess);

  const notify = useCallback(({ type, message }) => {
    if (type === 'success') {
      toast.success(message);
    } else if (type === 'error') {
      toast.error(message);
    } else {
      toast(message);
    }
  }, []);

  const notifyApiError = useCallback(
    (error) => {
      notify({
        type: 'error',
        message: error.response?.data?.message || 'Something went wrong',
      });
    },
    [notify]
  );

  const notifySuccess = useCallback(
    (message) => {
      notify({ type: 'success', message });
    },
    [notify]
  );

  useEffect(() => {
    setNotify(notify);
    setNotifyApiError(notifyApiError);
    setNotifySuccess(notifySuccess);
  }, [
    notify,
    notifyApiError,
    notifySuccess,
    setNotify,
    setNotifyApiError,
    setNotifySuccess,
  ]);

  return (
    <>
      {createPortal(<DialogModal />, document.body)}
      <ToastContainer />
    </>
  );
}
